export default __webpack_public_path__ + "static/StoryBoard-a52f4bfe543b054a6399685688bfd5ce.jpg";